<template>
  <router-view>
    <h1>LOADING</h1>
  </router-view>
</template>

<script>
import moment from "moment";

import {EXPIRES_IN, ID_TOKEN, TOKEN_TYPE, USER_NS, USER_TOKEN} from "../store/modules/user/constants";
import {mapActions} from "vuex";
import {parameters} from "../parameters";

export default {
  name: "Fed",
  methods: {
    ...mapActions(USER_NS,
      ['updateUserNameFromJwt']
    )
  },
  mounted () {

    const codeVerifier = sessionStorage.getItem('codeVerifier')
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')

    let xhr = new XMLHttpRequest();

    const updateUserName = this.updateUserNameFromJwt

    xhr.addEventListener("readystatechange", function() {
      if(this.readyState === 4) {

        const jsonText = xhr.responseText
        const jsonToken = JSON.parse(jsonText)
        sessionStorage.setItem(USER_TOKEN, jsonToken.access_token)
        updateUserName(jsonToken.access_token)
        sessionStorage.setItem(EXPIRES_IN, moment().add(jsonToken.expires_in, 'seconds').toISOString())
        sessionStorage.setItem(TOKEN_TYPE, jsonToken.token_type)
        sessionStorage.setItem(ID_TOKEN, jsonToken.id_token)

        location.replace(sessionStorage.getItem('poslog_url_backup'));
      }
    });

    xhr.open(
      "POST",
      parameters.fedUrl + `/as/token.oauth2`,
      false
    );

    xhr.setRequestHeader("cache-control", "no-cache");

    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

    xhr.send(`grant_type=authorization_code&client_id=${parameters.clientId}&code=${code}&redirect_uri=${parameters.redirectUri}&code_verifier=${codeVerifier}`);
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Fed.vue